import { Link } from "react-router-dom";
import { MapPin, CheckCircle2 } from "lucide-react";
import { useApi, eventImage } from "@/lib/api";
import { Page, Spinner, Empty } from "@/components/common";
import { fmtDate } from "@/components/EventCard";

const TicketRow = ({ t, i }) => {
  const e = t.event || t;
  const id = e.id || t.event_id;
  const checked = t.checked_in || t.checked_in_at || t.signup?.checked_in;
  return (
    <Link to={`/events/${id}`} data-testid={`ticket-${t.id || id}`} style={{ animationDelay: `${i * 60}ms` }}
      className="rise flex rounded-3xl bg-white border border-stone-200 overflow-hidden hover:border-stone-900 transition-colors">
      <img src={eventImage(e)} alt="" className="w-28 sm:w-44 object-cover bg-stone-200" />
      <div className="flex-1 p-5 min-w-0 sm:border-r-2 border-dashed border-stone-200">
        <p className="font-mono text-[11px] uppercase tracking-widest text-[#C2410C]">{fmtDate(e.start_time)}</p>
        <p className="font-display text-xl font-bold truncate">{e.title}</p>
        <p className="text-sm text-stone-500 flex items-center gap-1 truncate"><MapPin className="h-3.5 w-3.5" />{e.location_name}</p>
        {e.cancelled && <span className="mt-2 inline-block font-mono text-[10px] bg-red-600 text-white px-2 py-0.5 rounded-full">Cancelled</span>}
      </div>
      <div className="hidden sm:flex w-28 flex-col items-center justify-center gap-1 p-3 text-center">
        {checked ? <><CheckCircle2 className="h-6 w-6 text-emerald-600" /><span className="font-mono text-[10px] uppercase">Checked in</span></> : <><span className="font-display text-2xl font-black">ADMIT</span><span className="font-mono text-[10px] text-stone-500">ONE</span></>}
      </div>
    </Link>
  );
};

export default function Tickets() {
  const { data, isLoading } = useApi("/tickets");
  const tickets = data?.tickets || [];
  const now = new Date();
  const upcoming = tickets.filter((t) => new Date((t.event || t).end_time) >= now);
  const past = tickets.filter((t) => new Date((t.event || t).end_time) < now);
  return (
    <Page className="max-w-4xl">
      <p className="font-mono text-xs uppercase tracking-widest text-stone-500">Wallet</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">My tickets</h1>
      <div className="mt-10 space-y-4">
        {isLoading ? <Spinner /> : tickets.length === 0 ? (
          <Empty title="No tickets yet" testId="tickets-empty"><Link to="/events" className="font-semibold text-[#FF5C00]">Find something to do</Link></Empty>
        ) : (
          <>
            {upcoming.map((t, i) => <TicketRow key={t.id || i} t={t} i={i} />)}
            {past.length > 0 && <p className="pt-6 font-mono text-xs uppercase tracking-widest text-stone-500">Past</p>}
            {past.map((t, i) => <TicketRow key={t.id || `p${i}`} t={t} i={i} />)}
          </>
        )}
      </div>
    </Page>
  );
}
